import { useEffect } from 'react';
import './ModalOverlay.css';

export default function ModalOverlay({ onClose, zIndex = 200, children }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="modal-overlay"
      style={zIndex !== 200 ? { zIndex } : undefined}
      onClick={onClose}
    >
      <div className="modal-overlay__inner" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
